import get from 'lodash.get'
import { useContext } from 'react'
import AuthContext from '../../contexts/AuthContext'

export const useTolOperation = () => {
  const { idTokenPayload, namespace } = useContext(AuthContext)
  const userMetadata = get(idTokenPayload, `${namespace}/user_metadata`, {})
  const tolOperation = userMetadata['tol-operation'] || {}

  return {
    hasNotificationPermission: tolOperation.notification === true,
    hasOtacMaintenancePermission: tolOperation.otacMaintenance === true,
    hasTolOperationAccess: tolOperation.notification === true || tolOperation.otacMaintenance === true,
  }
}
